import { IApplicationState } from '../../types/redux';

export const selectPageTitle = (state: IApplicationState): string => {
  return state.seoData.h1;
};
